(() => {
  const valuesFor = variant => variant.options || [variant.option1,variant.option2,variant.option3].filter(value => value != null);
  const palette = {
    black:'#171717',white:'#fffdf9',pink:'#edabc2',grey:'#969696',gray:'#969696',mint:'#a5d6bd',
    'deep purple':'#633b80','light purple':'#c4a8dc',purple:'#8957aa',puple:'#8957aa',
    'butter yellow':'#f4e3a2','cloud blue':'#bfd8e8','pink nude':'#d9b5ad',nude:'#d4b69d',
    yellow:'#edcd51','light blue':'#a7cce6','dark blue':'#253f72','lime green':'#b5d653',
    mauve:'#b58b9e',burgundy:'#742b40',red:'#c73f44',green:'#4c805c',brown:'#80563e',
    creme:'#f0e4ce',cream:'#f0e4ce',creamy:'#f0e4ce',creame:'#f0e4ce',blue:'#4c80ba',
    'pastel blue':'#b9d6e9','pastel green':'#c1dbc1','navy blue':'#26334f',navy:'#26334f',
    'dark grey':'#55565a',taupe:'#ad9a89',lilac:'#c6a4d3','washed grey':'#a4a3a1',
    espresso:'#483028','light green':'#bad4a0',sand:'#d4bf9c',beige:'#d9c8ac',
    'sage green':'#a9b7a0','baby blue':'#afd3ed','baby pink':'#f1bdca',charcoal:'#414345',
    cocoa:'#866250',olive:'#788052',olivegreen:'#788052','olive green':'#788052',
    'hot pink':'#e74791','royal blue':'#365dc1','rose pink':'#d38d9f','light brown':'#b18a68',
    'pine green':'#365c4b','dark brown':'#573c2e','cadet grey':'#929e9e','woody brown':'#785744',
    'washed black':'#4b4b4a','light grey':'#cbcbcb',camel:'#c39765',khaki:'#b8aa7a',
    'nude pink':'#dfb6ab','burnt orange':'#bd663d',denim:'#567995','grayish green':'#8c9b8b',
    'grey coffee':'#93827b','dark green':'#2f5943',teal:'#3f8586','off white':'#f5f0e4'
  };
  const normalizeColor = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s*-\s*/g,' ').trim();
  const paintFor = value => {
    const key = normalizeColor(value);
    if (palette[key]) return palette[key];
    const parts = key.split(/\s+on\s+|\s*&\s*|\s*\/\s*/).map(p => palette[p]);
    if (parts.length > 1 && parts.every(Boolean)) return `linear-gradient(135deg,${parts[0]} 50%,${parts[1]} 50%)`;
    if (CSS.supports('color',key)) return key;
    return 'repeating-linear-gradient(135deg,#e6ded4 0 5px,#b8aaa0 5px 7px)';
  };
  window.initSlimieeVariants = (container, {product, selectedId, colorOnly = false, onChange}) => {
    const variants = product.variants || [];
    const first = variants.find(v => String(v.id) === String(selectedId)) || variants.find(v => v.available) || variants[0];
    const initial = first ? valuesFor(first) : [];
    const options = (product.options || []).map((option,index) => ({
      name:typeof option === 'string' ? option : option.name,
      values:typeof option === 'object' && option.values ? option.values : [...new Set(variants.map(v => valuesFor(v)[index]))].filter(value => value != null)
    })).filter(option => option.name !== 'Title' || option.values.some(value => value !== 'Default Title'));
    let selected = [...initial];
    let current = first || null;
    const controls = options.map((option,index) => {
      if (colorOnly && !/^colou?r$/i.test(option.name)) return null;
      if (/^colou?r$/i.test(option.name)) {
        const field = document.createElement('fieldset');
        field.className = 'variant-option color-dot-field';
        const legend = document.createElement('legend');legend.textContent = 'Color';
        const group = document.createElement('div');group.className = 'color-dot-group';
        group.setAttribute('role','radiogroup');group.setAttribute('aria-label',option.name);
        group.dataset.optionName = option.name;
        const buttons = option.values.map(value => {
          const button = document.createElement('button');
          button.type = 'button';button.className = 'color-dot';button.dataset.colorValue = value;
          button.setAttribute('role','radio');button.setAttribute('aria-label',value);button.title = value;
          const chip = document.createElement('span');chip.className = 'color-dot-paint';chip.setAttribute('aria-hidden','true');
          const native = product.colorSwatches?.find(s => s.name === value);
          chip.style.background = native?.color && CSS.supports('color',native.color) ? native.color : paintFor(value);
          if (native?.image) { const image = document.createElement('img');image.src = native.image;image.alt = '';chip.replaceChildren(image); }
          button.append(chip);
          button.addEventListener('click', () => {
            selected[index] = value;
            if (colorOnly) {
              const matches = variants.filter(v => valuesFor(v)[index] === value);
              const preferred = matches.find(v => v.available) || matches[0];
              if (preferred) selected = [...valuesFor(preferred)];
            }
            update();
          });
          group.append(button);return button;
        });
        selected[index] = initial[index] || option.values[0];
        group.addEventListener('keydown',event => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const at = buttons.findIndex(button => button.dataset.colorValue === selected[index]);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length-1 : (at + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].click();buttons[next].focus();
        });
        field.append(legend,group);container.append(field);
        return {buttons};
      }
      const label = document.createElement('label');
      label.className = 'variant-option';
      const text = document.createElement('span');
      text.textContent = /^colou?r$/i.test(option.name) ? 'Select a color' : /^size$/i.test(option.name) ? 'Select a size' : `Select ${option.name.toLowerCase()}`;
      const select = document.createElement('select');
      select.className = 'store-variant';
      select.dataset.optionName = option.name;
      option.values.forEach(value => select.add(new Option(value,value)));
      select.value = initial[index] || option.values[0];
      selected[index] = select.value;
      select.addEventListener('change', () => { selected[index] = select.value; update(); });
      label.append(text,select);
      container.append(label);
      return {select};
    });
    function update() {
      current = variants.find(v => valuesFor(v).every((value,index) => value === selected[index])) || null;
      controls.forEach((control,index) => {
        if (!control) return;
        const entries = control.select ? [...control.select.options] : control.buttons;
        entries.forEach(entry => {
          const value = control.select ? entry.value : entry.dataset.colorValue;
          const matches = variants.filter(v => colorOnly ? valuesFor(v)[index] === value : valuesFor(v).every((item,i) => item === (i === index ? value : selected[i])));
          const unavailable = !matches.length || !matches.some(v => v.available);
          const suffix = !matches.length ? ' — Unavailable' : unavailable ? ' — Sold out' : '';
          if (control.select) entry.textContent = value + suffix;
          else {
            const checked = value === selected[index];
            entry.setAttribute('aria-checked',String(checked));entry.tabIndex = checked ? 0 : -1;
            entry.setAttribute('aria-label',value + suffix);entry.title = value + suffix;
            entry.classList.toggle('is-selected',checked);entry.classList.toggle('is-unavailable',unavailable);
          }
        });
      });
      onChange?.(current);
    }
    update();
    return {getSelectedVariant: () => current, setSelectedVariant: id => {
      const variant = variants.find(v => String(v.id) === String(id));
      if (variant) { selected = [...valuesFor(variant)]; controls.forEach((control,index) => { if (control?.select) control.select.value = selected[index]; });update(); }
    }};
  };
  const init = root => {
    if (root.dataset.variantsReady) return;
    root.dataset.variantsReady = 'true';
    const product = JSON.parse(root.dataset.product);
    if (root.dataset.colorSwatches) product.colorSwatches = JSON.parse(root.dataset.colorSwatches);
    const form = root.querySelector('form');
    const variantSelect = form.querySelector('[name="id"]');
    const button = form.querySelector('[type="submit"]');
    const price = root.querySelector('[data-variant-price]');
    const status = root.querySelector('[data-variant-status]');
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:root.dataset.currency || 'USD'}).format(value/100);
    let active;
    const defaultImage = root.querySelector('[data-product-photo]')?.getAttribute('src');
    root.querySelector('[data-variant-fallback]').hidden = true;
    const picker = root.querySelector('[data-variant-options]');
    picker.hidden = false;
    window.initSlimieeVariants(picker, {product,selectedId:variantSelect.value,onChange:variant => {
      active = variant;
      variantSelect.value = variant ? String(variant.id) : '';
      button.disabled = !variant?.available;
      button.textContent = !variant ? 'Unavailable combination' : !variant.available ? 'Sold out' : 'Add to bag';
      status.textContent = !variant ? 'This combination is unavailable. Choose another color or size.' : !variant.available ? 'This option is sold out.' : '';
      price.textContent = money(variant ? variant.price : product.price);
      const dynamicCheckout = form.querySelector('.shopify-payment-button');
      if (dynamicCheckout) dynamicCheckout.hidden = !variant?.available;
      const image = variant?.featured_image?.src || variant?.image?.src || (typeof variant?.image === 'string' ? variant.image : null) || defaultImage;
      if (image && root.querySelector('[data-product-photo]')) {
        const photo = root.querySelector('[data-product-photo]');photo.removeAttribute('srcset');photo.src = image;
      }
    }});
    const colors = picker.querySelector('.color-dot-field');
    const photo = root.querySelector('[data-product-photo]');
    if (colors && photo) { colors.classList.add('under-photo-colors');photo.insertAdjacentElement('afterend',colors); }
    form.addEventListener('submit',event => { if (!active?.available) event.preventDefault(); });
  };
  document.querySelectorAll('[data-product-variants]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-product-variants]').forEach(init));
})();
